import React from "react";
import YieldReport from "../../../common/reports/yield";

const YieldIndex = props => {
  return <YieldReport collabType="CMO" {...props} />;
};

export default YieldIndex;
